import type { ContactChannel, InputField, SelectOption } from './types';

export const contactContent = {
    sectionTitle: 'Contact Us',
    details: {
        heading: 'Get In Touch',
        // Email/phone values come from Vite's built-in `VITE_`-prefixed env
        // vars (see `.env.example` and `src/vite-env.d.ts`), exposed to the
        // client via `import.meta.env` — no custom `define` wiring needed.
        channels: [
            {
                icon: 'mail',
                label: 'General Inquiry',
                value: import.meta.env.VITE_GENERAL_INQUIRY_EMAIL,
            },
            { icon: 'receipt', label: 'Sales Inquiry', value: import.meta.env.VITE_SALES_EMAIL },
            {
                icon: 'headset',
                label: 'Customer Service',
                value: import.meta.env.VITE_CUSTOMER_SERVICE_EMAIL,
            },
            { icon: 'phone', label: 'Direct Line', value: import.meta.env.VITE_DIRECT_LINE },
        ] satisfies ContactChannel[],
    },
    form: {
        fields: [
            { type: 'text', name: 'Full_Name', placeholder: 'Full Name', ariaLabel: 'Full Name' },
            {
                type: 'email',
                name: '_replyto',
                placeholder: 'Business Email',
                ariaLabel: 'Business Email',
            },
            {
                type: 'tel',
                name: 'Phone_Number',
                placeholder: 'Phone Number',
                ariaLabel: 'Phone Number',
            },
        ] satisfies InputField[],
        subject: {
            name: '_subject',
            ariaLabel: 'Area of Interest',
            options: [
                { value: '', label: 'Area of Interest', disabled: true },
                { value: 'General Inquiry', label: 'General Inquiry' },
                { value: 'Sales Inquiry', label: 'Sales Inquiry' },
                { value: 'Customer Service Inquiry', label: 'Customer Service Inquiry' },
            ] satisfies SelectOption[],
        },
        message: {
            name: 'Message',
            placeholder: 'Tell us about your requirements...',
            ariaLabel: 'Tell us about your requirements...',
            rows: 4,
        },
        submit: {
            idle: 'Send Message',
            sending: 'Sending...',
        },
        success: {
            title: 'Thanks!',
            message: 'Your inquiry was submitted successfully.',
        },
        errors: {
            submit: 'Oops! There was a problem submitting your inquiry.',
            connection: 'Oops! There was a connection error.',
        },
    },
};
